// ActionCellClinicDoctor.jsx
import React, { useRef } from "react";
import { Whisper, Popover } from "rsuite";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEdit, FaRegEye, FaCheckCircle } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { RiRepeat2Fill } from "react-icons/ri";
import { FaRegCalendarAlt } from "react-icons/fa";
import {
  useActivateDoctorMutation,
  useDeactivateDoctorMutation
} from "../../State/Api/AdddocApiSlice";

const ActionCellClinicDoctor = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const triggerRef = useRef(null);

  const [deactivateDoctor] = useDeactivateDoctorMutation();
  const [activateDoctor] = useActivateDoctorMutation();

  const closePopover = () => triggerRef.current?.close();

  const notifyStatusUpdated = () => {
    window.dispatchEvent(
      new CustomEvent("doctors:status-updated", {
        detail: { userUniqueID: data?.userUniqueID }
      })
    );
  };

  const handleSchedule = () => {
    window.dispatchEvent(
      new CustomEvent("scheduleDoctor", {
        detail: {
          doctorId: data?.doctorID,
          fullName: data?.fullName,
          specialization:data?.specialization,
          userUniqueID: data?.userUniqueID
        }
      })
    );
    closePopover();
  };

  // robust availability flag (from prior fix)
  const rawStatus =
    data?.isactive ?? data?.isActive ?? data?.status ?? data?.availability ?? "";
  const status = String(rawStatus).trim().toLowerCase();
  const isAvailable =
    status === "available" ||
    status === "active" ||
    status === "true" ||
    status === "1" ||
    status === "yes";

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-48">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">Actions</div>

     <div
  onClick={() => {
    navigate(`/DoctorsAdd/${data?.userUniqueID}?from=${encodeURIComponent(
              location.pathname + location.search
            )}`);  
    closePopover();
  }}
  className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
>
  <FaEdit className="text-lg text-[#55c999]" />
  <span>Edit</span>
</div>

      {isAvailable && (
        <div
          onClick={async () => {
            const formData = new FormData();
            formData.append("userUniqueID", data?.userUniqueID);
            await deactivateDoctor(formData).unwrap();
            notifyStatusUpdated();
            closePopover();
          }}
          className="flex items-center gap-2 px-3 py-2 text-sm text-red-600 cursor-pointer hover:bg-gray-100 rounded-md"
        >
          <MdDeleteOutline className="text-lg" />
          <span>Mark Unavailable</span>
        </div>
      )}

      {!isAvailable && (
        <div
          onClick={async () => {
            const formData = new FormData();
            formData.append("userUniqueID", data?.userUniqueID);
            await activateDoctor(formData).unwrap();
            notifyStatusUpdated();
            closePopover();
          }}
          className="flex items-center gap-2 px-3 py-2 text-sm text-green-600 cursor-pointer hover:bg-gray-100 rounded-md"
        >
          <FaCheckCircle className="text-lg" />
          <span>Mark Available</span>
        </div>
      )}

      <div
        onClick={() => {
          navigate(
            `/DoctorProfile/${data?.userUniqueID}?from=${encodeURIComponent(
              location.pathname + location.search
            )}`
          );
          closePopover();
        }}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaRegEye className="text-lg text-[#383838]" />
        <span>View Profile</span>
      </div>

      {isAvailable && (<div
        onClick={() => {
          navigate("/AddAppointment", {
            state: {
              showModal: true,
              doctorName: data?.fullName,
              doctorSpecialization: data?.specialization,
              fromDoctorView: true,
              from: location.pathname
            }
          });
        }}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaRegCalendarAlt className="text-lg text-[#383838]" />
        <span>Make Appointment</span>
      </div>)}

      {isAvailable && (<div
        onClick={handleSchedule}
        className="flex items-center gap-2 px-3 py-2 text-sm text-[#45B369] cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <RiRepeat2Fill className="text-lg" />
        <span>Schedule</span>
      </div>)}
    </Popover>
  );

  return (
    <Whisper ref={triggerRef} placement="autoVerticalEnd" trigger="click" speaker={renderPopover}>
      <button
        className="inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-gray-100"
        title="More actions"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>
      </button>
    </Whisper>
  );
};

export default ActionCellClinicDoctor;
